import React, { PropsWithChildren, useEffect } from 'react'
import { CabinetUpdateContext, ICabinetUpdateContext, UpdateCabinetData } from '../../../context/cabinet'
import { useCabinetInfo } from '../../../store/selectors/cabinet'
import { useAppDispatch } from '../../../store/hooks'
import { updateCabinetActive, updateCabinetInfo } from '../../../store/cabinet/thunk'
import { useLoadSpinContext } from '../../../context/loadSpinContext'
import { setCabinetInfo } from '../../../store/cabinet/reduser'

export const CabinetUpdateProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const { cabinetInfo } = useCabinetInfo();
  const { setLoad } = useLoadSpinContext();

  const { updating, loading } = useCabinetInfo();

  const updateCabinet = async (cabinetId: string, data: UpdateCabinetData) => {
    const res = await dispatch(updateCabinetInfo(cabinetId, data))

    if (res === true) {
      if (cabinetInfo && cabinetInfo.id === cabinetId) {
        dispatch(setCabinetInfo({
          ...cabinetInfo,
          ...data
        }))
      }
    }

    return res;
  }

  const updateCabinetActiveState = async (cabinetId: string, active: boolean) => {
    const res = await dispatch(updateCabinetActive(cabinetId, active))

    if (res === true) {
      if (cabinetInfo && cabinetInfo.id === cabinetId) {
        dispatch(setCabinetInfo({
          ...cabinetInfo,
          active
        }))
      }
    }

    return res;
  }

  useEffect(() => {
    setLoad(updating || loading);
  }, [updating, loading])

  useEffect(() => {
    return () => {
      setLoad(false);
    }
  }, [])

  const context: ICabinetUpdateContext = {
    updating,

    update: updateCabinet,
    updateActive: updateCabinetActiveState,
  }

  return (
    <CabinetUpdateContext.Provider value={context}>
      {children}
    </CabinetUpdateContext.Provider>
  )
}
